import React from "react";
import {
  StepContent,
  DetailSectionTitle,
  InfoBanner,
  InfoBannerIcon,
  ErrorBanner,
  LoadingContainer,
  LoadingText,
  ThinkingDots,
  RemoteDetailGrid,
  RemoteDetailRow,
  CodeBlock,
} from "../styles";
import type { VerifyConnectionResult } from "../../../store/api/dataSourcesApi";

interface StepVerifyIndexProps {
  isVerifying: boolean;
  verifyResult: VerifyConnectionResult | null;
  verifyError: string | null;
  indexName: string;
}

const StepVerifyIndex: React.FC<StepVerifyIndexProps> = ({
  isVerifying,
  verifyResult,
  verifyError,
  indexName,
}) => {
  if (isVerifying) {
    return (
      <StepContent>
        <LoadingContainer>
          <ThinkingDots>
            <span />
            <span />
            <span />
          </ThinkingDots>
          <LoadingText>
            Connecting to Algolia and verifying index...
          </LoadingText>
        </LoadingContainer>
      </StepContent>
    );
  }

  if (verifyError) {
    return (
      <StepContent>
        <ErrorBanner>{verifyError}</ErrorBanner>
        <p>Please go back and check your credentials, then try again.</p>
      </StepContent>
    );
  }

  if (verifyResult && verifyResult.verified) {
    const schemaFieldCount = Object.keys(verifyResult.schema).length;

    return (
      <StepContent>
        <DetailSectionTitle>Verified Index</DetailSectionTitle>

        <InfoBanner>
          <InfoBannerIcon>{"\u2705"}</InfoBannerIcon>
          <span>Successfully connected to your Algolia index.</span>
        </InfoBanner>

        <RemoteDetailGrid>
          <RemoteDetailRow>
            <span>Index Name</span>
            <strong>{indexName}</strong>
          </RemoteDetailRow>
          <RemoteDetailRow>
            <span>Supported Operations</span>
            <strong>
              {verifyResult.supportedOperations.length > 0
                ? verifyResult.supportedOperations.join(", ")
                : "N/A"}
            </strong>
          </RemoteDetailRow>
          <RemoteDetailRow>
            <span>Schema Fields</span>
            <strong>
              {schemaFieldCount > 0
                ? `${schemaFieldCount} fields`
                : "Auto-detected"}
            </strong>
          </RemoteDetailRow>
        </RemoteDetailGrid>

        {verifyResult.sampleRecords.length > 0 && (
          <>
            <DetailSectionTitle>Sample Records</DetailSectionTitle>
            <CodeBlock>
              {JSON.stringify(verifyResult.sampleRecords.slice(0, 2), null, 2)}
            </CodeBlock>
          </>
        )}
      </StepContent>
    );
  }

  return <StepContent />;
};

export default StepVerifyIndex;
